module.exports = __webpack_public_path__ + "b5c2afaa0c6b540d381975a464dd2d39.jpg";